/*eslint-disable*/
import Loading from 'components/common/loaders/Loading';
import I18n from 'hooks/useI18n';
import JSEncrypt from 'jsencrypt';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useCallback, useEffect, useRef, useState } from 'react';

import Img from 'components/common/Img';
import { updateCommonStateReducerSuccess, updateStateCommonState } from 'redhotpie-shared-lib/actions/commonStateAction';
import urls from 'redhotpie-shared-lib/api/urls';
import { SAFARI } from 'redhotpie-shared-lib/constants/browserTypes';
import { TYPE_GROUP_CHAT } from 'redhotpie-shared-lib/constants/chatTypes';
import { EXTERNAL_LINKS, EXTERNAL_ROOT_LINKS } from 'redhotpie-shared-lib/constants/config';
import {
  MEMBER_LEVEL,
  MESSAGE_RECEIVE_PERMISSION,
  MIN_DIMENSION_IMAGE,
  PUSHY_CONFIG,
  SCROLL,
  SESSIONS,
  StreamFilterTooltip,
  STYLE_MODAL,
  THEMES,
} from 'redhotpie-shared-lib/constants/constants';
import { CLEAR_COUNTDOWN, SHOW_QUICK_MESSAGE_MODAL } from 'redhotpie-shared-lib/constants/eventTypes';
import * as messageTypes from 'redhotpie-shared-lib/constants/messageTypes';
import {
  ADD_YOUR_PHOTO,
  ALL_PROPERTY_VIEW,
  DATE_FINDER_PAGE,
  EDIT_PROFILE,
  FEED_HOME,
  MAIN_SETTING,
  PROSPECT,
  QUICK_REGISTRATION,
  QUICK_REGISTRATION_2,
  ROOT_FOLDER,
} from 'redhotpie-shared-lib/constants/routes';
import { storageHelper } from 'redhotpie-shared-lib/functions';
import { detectBrowser, detectIos, getOS, handleShowConfirmModal, phoneDetect } from 'redhotpie-shared-lib/functions/utils';
// Only the tiny query-string helper is needed here. Importing the whole WebIM
// wrapper would drag the XMPP SDK (strophe, crypto-js, xmldom) into every
// bundle that touches webUtils.
import { utils as webIMUtils } from 'redhotpie-shared-lib/sdks/src/utils';
import WebIMConfig from 'redhotpie-shared-lib/libs/webIMConfig';
import locationService from 'redhotpie-shared-lib/services/locationService';
import pushyServices from 'redhotpie-shared-lib/services/pushyServices';
import userService from 'redhotpie-shared-lib/services/userService';
import { getStore } from 'redhotpie-shared-lib/store/myStore';
import {
  icCameraBlue,
  icCameraGreen,
  icCameraPink,
  icCameraPurple,
  icChevronBlueRight,
  icChevronGreenRight,
  icChevronPinkRight,
  icChevronPurpleRight,
  icDiamondBlack,
  icDiamondMember,
  icSend,
  icSendBlue,
  icSendPink,
  icSendPurple,
  icVoiceBlue,
  icVoiceGreen,
  icVoicePink,
  icVoicePurple,
  loadingGreen,
} from 'redhotpie-shared-lib/themes/ImagesSVG';
import { convertMsDateToUnixTimestamp } from '../redhotpie-shared-lib/functions/utils';

const decrypt = new JSEncrypt();
const privateKey = process.env.REACT_APP_RSA_PRIVATE_KEY;
decrypt.setPrivateKey(privateKey);

const encrypt = new JSEncrypt();
const publicKey = process.env.REACT_APP_RSA_PUBLIC_KEY;
encrypt.setPublicKey(publicKey);

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref, callbackOutside) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        if (callbackOutside) {
          callbackOutside(event);
        }
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export function useCountdown(seconds, callback) {
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [isInitCount, setInitCount] = useState(false);
  const [timeDefault, setTimeDefault] = useState(seconds);
  const intervalRef = useRef();

  useEffect(() => {
    if (timeLeft && isInitCount) {
      initCount();
      setInitCount(false);
    }
  }, [timeLeft, isInitCount]);

  const initCount = useCallback(() => {
    if (timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(t => t - 1);
      }, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [timeLeft]);
  // useEffect(() => {
  //   if (seconds > 0) {
  //     initCount();
  //   }
  // }, []);

  const clearCountdown = useCallback(() => {
    clearInterval(intervalRef.current);
  }, []);

  // Add a listener to `timeLeft`
  useEffect(() => {
    if (timeLeft <= 0) {
      clearInterval(intervalRef.current);
      timeDefault > 0 && callback?.();
    }
  }, [timeLeft]);

  return { timeLeft, initCount, setTimeLeft, clearCountdown, setInitCount, setTimeDefault, isInitCount };
}

// Hook
export function useEventListener(eventName, handler, el, options = {}) {
  let element = el || document;
  // Create a ref that stores handler
  const savedHandler = useRef();

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      // Make sure element supports addEventListener
      // On
      const isSupported = element && element.addEventListener;
      if (!isSupported) return;

      // Create event listener that calls handler function stored in ref
      const eventListener = event => savedHandler.current(event);

      // Add event listener
      element.addEventListener(eventName, eventListener, options);

      // Remove event listener on cleanup
      return () => {
        element.removeEventListener(eventName, eventListener, options);
      };
    },
    [eventName, element] // Re-run if eventName or element changes
  );
}

export function getConversationItems(data, userSelectId) {
  let length = data.length;
  let conversation = null;
  for (let i = 0; i < length; i++) {
    if (userSelectId === data[i].peerVcard.userId) {
      conversation = data[i];
      break;
    }
  }
  return conversation;
}

export function getTitleDocumentByRoute(route) {
  const titleI18nText = route.documentTitle;
  return I18n.t(titleI18nText);
}

// const URL_SECURE_DOMAIN_URBAN_AIRSHIP = "https://web-sdk.urbanairship.com/notify/v1/ua-sdk.min.js";

export function handleSecureDomainBridgeUrbanAirship() {
  // let script = document.querySelector(`script[src="${URL_SECURE_DOMAIN_URBAN_AIRSHIP}"]`);
  // if (script) {
  //   return;
  // }
  // script = document.createElement( "script" );
  // script.type = "text/javascript";
  // script.rel = "secureBridge";
  // const callback = () => {
  //   // uaSetup.secureBridge({
  //   //   appKey: URBAN_AIRSHIP.APP_KEY
  //   // });
  // }
  // if(script.readyState) {  // only required for IE <9
  //   script.onreadystatechange = function() {
  //     if ( script.readyState === "loaded" || script.readyState === "complete" ) {
  //       script.onreadystatechange = null;
  //       callback();
  //     }
  //   };
  // } else {  //Others
  //   script.onload = function() {
  //     callback();
  //   };
  // }
  //
  // script.src = URL_SECURE_DOMAIN_URBAN_AIRSHIP;
  // document.getElementsByTagName( "head" )[0].appendChild( script );
}

export function loadScript(url, callback) {
  let script = document.querySelector(`script[src="${url}"]`);
  if (script) {
    // console.error('script is exist: ', url);
    return;
  }
  script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}

// export function loadUrbanAirshipSDK(callback) {
//     !function (n, r, e, t, c, cb) {
//       let i, o = "Promise" in n, u = {
//           then: function () {
//             return u
//           }, catch: function (n) {
//             return n(new Error("Airship SDK Error: Unsupported browser")), u
//           }
//         }, s = o ? new Promise((function (n, r) {
//           i = function (e, t) {
//             e ? r(e) : n(t)
//           }
//         })) : u
//       ;s._async_setup = function (n) {
//         if (o) try {
//           i(null, n(c))
//         } catch (n) {
//           i(n)
//         }
//       }, n[t] = s;
//       let a = r.createElement("script");
//
//       a.type = "text/javascript";
//       if (a.readyState) {  // only required for IE <9
//         a.onreadystatechange = function() {
//           if ( a.readyState === "loaded" || a.readyState === "complete" ) {
//             a.onreadystatechange = null;
//             cb && cb();
//           }
//         };
//       } else {  //Others
//         a.onload = function() {
//           cb && cb();
//         };
//       }
//
//       a.src = e, a.async = !0, a.id = URBAN_AIRSHIP.DOM_ELEMENT_ID,
//         a.rel = t, r.head.appendChild(a)
//     }(window, document, urls.URBAN_AIRSHIP_SDK_URL,
//       URBAN_AIRSHIP.VAR_NAME, {
//         vapidPublicKey: URBAN_AIRSHIP.VAPID_PUBLIC_KEY,
//         appKey: URBAN_AIRSHIP.APP_KEY,
//         token: URBAN_AIRSHIP.TOKEN,
//         // websitePushId: 'WEBSITE-PUSH-ID-FROM-UA',
//         // secureIframeUrl: 'https://your.secure.domain/path/to/web-push-secure-bridge.html',
//       }, callback);
// }

/**
 * Function set view port scalable
 * TODO: should not edit viewport as below, this just a temp solution and should find other way to resolve this issue
 */
export function setViewportScalable() {
  const viewport = document.querySelector('meta[name=viewport]');
  if (viewport && !detectIos()) {
    viewport.setAttribute('content', 'width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.5, minimal-ui');
  }
}

/**
 * Function set view port un-scalable
 * TODO: should not edit viewport as below, this just a temp solution and should find other way to resolve this issue
 */
export function setViewportUnScalable() {
  const viewport = document.querySelector('meta[name=viewport]');
  if (viewport) {
    viewport.setAttribute(
      'content',
      'width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, minimal-ui'
    );
  }
}

export function renderLoading(props) {
  let selectingCategory = props && props[props.selectingCategoryId] ? props[props.selectingCategoryId] : {};
  let indexTab = selectingCategory.indexTab || 0;
  if (
    selectingCategory &&
    selectingCategory.contentTabs &&
    selectingCategory.contentTabs[indexTab] &&
    selectingCategory.contentTabs[indexTab].data &&
    selectingCategory.contentTabs[indexTab].data.length
  ) {
    return null;
  }
  return <Loading icon={loadingGreen} className="loadingTransparent" />;
}

export function renderLoadingAfterCallAPI() {
  return <Loading icon={loadingGreen} className="loadingTransparent" />;
}

export function countWord(str) {
  const regex = /\s+/gi;
  return str && str.trim().replace(regex, ' ').split(' ').length;
}

renderLoading.propTypes = {
  selectingCategoryId: PropTypes.string,
};

export function getCurNode(searchString) {
  let uri = webIMUtils.parseUri(searchString);
  // console.log("uri",uri);
  let curNode = uri.curNode;
  if (curNode && curNode !== 'undefined' && curNode !== 'null') {
    return curNode;
  } else {
    return '';
  }
}

export function isGroupView() {
  let uri = webIMUtils.parseUri();
  let curNode = uri.gr;
  return curNode === 'true';
}

export function getBurl() {
  let uri = webIMUtils.parseUri();
  return uri.burl || '';
}

export function getFolderId() {
  let uri = webIMUtils.parseUri();
  return uri.folderId || '';
}

export function getParamD() {
  let uri = webIMUtils.parseUri();
  return uri.d || '';
}

export function getParamUri(key) {
  let uri = webIMUtils.parseUri();
  return uri[key] || '';
}

export function onGotoUpgradeReportUser({ selectedUser, isMobile }) {
  let backUrl = window.location.search;
  let link = isMobile
    ? EXTERNAL_LINKS.REPORT_USER_MOBILE.replace(EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE, '')
        .replace('{backUrl}', backUrl)
        .replace('{userName}', selectedUser.displayName)
        .replace('{userId}', selectedUser.userId)
    : EXTERNAL_LINKS.REPORT_USER_DESKTOP.replace(EXTERNAL_ROOT_LINKS.ROOT_REDHOTPIE, '').replace('{userName}', selectedUser.displayName);

  window.open(link, '_parent');
}

export function createMarkup(content) {
  return { __html: content };
}

export function getUserId(user) {
  return user && (user.userId || (user.detail ? user.detail.userId : null));
}

export function isFireFox() {
  const userAgent = navigator?.userAgent?.toLowerCase();
  return userAgent?.indexOf?.('firefox') > -1;
}

export function detectIsFireFoxIE() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isFirefox = userAgent.indexOf('firefox') > -1;
  const isIE = userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident/') || userAgent.indexOf('edge/');
  return isFirefox || isIE;
}

export function findUserId(viewProfilePopup) {
  let viewProfileId = null;
  if (viewProfilePopup && viewProfilePopup.userId) {
    viewProfileId = viewProfilePopup.userId;
  }
  if (viewProfilePopup && viewProfilePopup.detail) {
    viewProfileId = viewProfilePopup.detail.userId;
  }
  return viewProfileId;
}

export function emptyFunc() {}

export function onGetUserNameAndDot(userName, limitCharacter) {
  return userName.length > limitCharacter ? userName.substr(0, limitCharacter).concat('...') : userName;
}

const isActiveModule = {
  prospect: page => page && page === PROSPECT,
  dateFinder: page => page && page === DATE_FINDER_PAGE,
};

export function isSafari() {
  return (
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') !== -1 &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1
  );
}

export function isShowApplePayButton() {
  return false;
  // return isSafari();
}

export function isShowGooglePayButton() {
  return false;
  // return !isSafari();
}

export function countWordWithCharacter(str, char) {
  let count = 0;
  if (str) {
    for (let i = 0; i < str.length; i++) {
      if (str.charAt(i) === char) {
        count++;
      }
    }
  }
  return count;
}

export { isActiveModule };

export function isSupportOverlayScroll() {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
  return isChrome || isSafari;
}

const createImage = url => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });
};

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
export function getCroppedImg(imageSrc, pixelCrop) {
  // console.log("pixelCrop", pixelCrop);
  return new Promise(resolve => {
    createImage(imageSrc).then(image => {
      if (image) {
        const canvas = document.createElement('canvas');
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);

        // As Base64 string
        // return canvas.toDataURL('image/jpeg');

        // As a blob
        canvas.toBlob(file => {
          resolve(file);
          // resolve(URL.createObjectURL(file));
        }, 'image/png');
      } else {
        resolve(null);
      }
    });
  });
}

export function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

export function parseUrlSearch(search) {
  const arr = [];
  if (typeof search !== 'string') {
    return arr;
  }
  search = search.trim().replace(/^[?#&]/, '');

  if (!search) {
    return arr;
  }

  search.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=');
    // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37
    const key = parts.shift();
    const val = parts.length > 0 ? parts.join('=') : undefined;
    const obj = Object.create(null);
    // obj.key = key;
    obj[key] = val;

    arr.push(obj);
  });

  return arr;
}

export function removeParam(key, search) {
  let rtn = '',
    param,
    params_arr = [];
  if (search !== '') {
    params_arr = search.split('&');
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    rtn = params_arr.join('&');
  }
  return rtn;
}

export function detectIsSafari() {
  let isSafari = false;
  const ua = navigator.userAgent.toLowerCase();
  if (
    ua.indexOf('safari') !== -1 &&
    ua.indexOf('iphone') !== -1 &&
    ua.indexOf('crios') === -1 &&
    ua.indexOf('fxios') === -1 &&
    ua.indexOf('chrome') === -1 &&
    ua.indexOf('android') === -1
  ) {
    isSafari = true;
  }

  return isSafari;
}

export function unregisterServiceWorker() {
  navigator &&
    navigator.serviceWorker &&
    navigator.serviceWorker.getRegistrations &&
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister && registration.unregister();
      }
    });
}

export function setUpServiceWorker() {
  // Register visitor's browser for push notifications
  if (navigator && navigator.serviceWorker) {
    // The Pushy SDK is only needed once a logged-in user reaches this point,
    // so it is loaded on demand instead of being part of the main bundle.
    import(/* webpackChunkName: "pushy-sdk" */ 'pushy-sdk-web')
      .then(({ default: Pushy }) => registerPushy(Pushy))
      .catch(err => console.error(err));
  }
}

function registerPushy(Pushy) {
  if (Pushy && !Pushy.isRegistered()) {
    const config = {
      appId: PUSHY_CONFIG.APP_ID,
    };
    if (process.env.NODE_ENV !== 'development') {
      config.serviceWorkerFile = 'rjsapp/service-worker.js';
    }
    Pushy.register(config)
      .then(deviceToken => {
        // Print device token to console
        console.log(`Pushy device token: ${deviceToken}`);
        deviceToken &&
          pushyServices.pushyRegisterToken({ DeviceToken: deviceToken }).then(res => {
            if (res && res.success) {
              // success case
            } else {
              // failed case
            }
          });
      })
      .catch(err => {
        // Handle registration errors
        console.error(err);
      });
  }

  Pushy &&
    Pushy.setNotificationListener(data => {
      // Print notification payload data
      console.log(`Received notification: ${JSON.stringify(data)}`);
    });
}

/**
 * We check permissionMessageReceive !== NO_ONE && permissionMessageReceive !== DIRECT_MESSAGE to determine if user able to receive message or not
 * This function used to check when user interest in an event
 * @returns boolean
 */
export function isAbleToReceiveMessage() {
  const {
    loginReducer: {
      userInfo: { messenger },
    },
  } = getStore().getState();
  return (
    messenger.permissionMessageReceive !== MESSAGE_RECEIVE_PERMISSION.NO_ONE &&
    messenger.permissionMessageReceive !== MESSAGE_RECEIVE_PERMISSION.DIRECT_MESSAGE
  );
}

export function handleGetLocation(currentLocation, callback) {
  const store = getStore();
  if (currentLocation) {
    let locationAfterGet = null;
    if (currentLocation.error && currentLocation.error.errorCode) {
      const {
        loginReducer: { userInfo },
      } = store.getState();

      if (userInfo && userInfo.locationInfo) {
        const { locationInfo } = userInfo;
        locationAfterGet = {
          placeId: locationInfo.suburb.GoogleMapPlacesId ? locationInfo.suburb.GoogleMapPlacesId : null,
          StateName: locationInfo.suburb && locationInfo.suburb.StateName ? locationInfo.suburb.StateName : null,
          countryPlaceId: locationInfo.country && locationInfo.country.GoogleMapPlacesId ? locationInfo.country.GoogleMapPlacesId : null,
          LocationType: locationInfo.suburb && locationInfo.suburb.LocationType ? locationInfo.suburb.LocationType : null,
        };
      }
      if (typeof callback === 'function') {
        callback(locationAfterGet);
      }
    } else {
      const {
        commonStateReducer: { currentLocation },
      } = store.getState();
      const { latitude, longitude } = currentLocation.coordinates;

      locationService.locationAutoComplete(null, true, { lat: latitude, lng: longitude }).then(res => {
        const paramUpdate = {
          ...currentLocation,
          loadSuccess: true,
        };
        delete paramUpdate.error;
        if (res.success) {
          const {
            data: { data },
          } = res;
          const location = data[0];
          paramUpdate.preCoordinates = {
            latitude: location.lat,
            longitude: location.lng,
          };
          paramUpdate.detail = {
            locality: {
              latitude: location.lat,
              longitude: location.lng,
              placeId: location.placeId,
              stateName: location.description,
            },
            country: {
              latitude: location.lat,
              longitude: location.lng,
              placeId: location.placeId,
              stateName: location.description,
            },
          };
          locationAfterGet = {
            placeId: location.placeId,
            StateName: location.description,
            countryPlaceId: location.placeId,
            LocationType: location.type,
            latitude: location.lat,
            longitude: location.lng,
          };
          store.dispatch(updateStateCommonState(['currentLocation'], paramUpdate));
          if (typeof callback === 'function') {
            callback(locationAfterGet);
          }
        }
      });
    }
  }
}

export function handleOpenVerifyPending() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowVerifyMessengerAccount: true,
    })
  );
}

export function checkSameString(nameFilter, nameWantCheck) {
  let encodeFilter = '';
  if (nameFilter.length > 0) {
    const tmpRex = new RegExp(`[ \`!@#$%^&*()_+\\-=\\[\\]{};':"\\\\|,.<>\\/?~]`);
    for (let i = 0; i < nameFilter.length; i++) {
      const char = nameFilter.charAt(i);
      if (tmpRex.test(char)) {
        encodeFilter += `\\${char}`;
      } else {
        encodeFilter += char;
      }
    }
  }
  const rex = new RegExp(`(${encodeFilter})`, 'ig');

  return rex.test(nameWantCheck);
}

export function coverObjectToQueryString(objects) {
  return Object.keys(objects)
    .map(key => `${key}=${objects[key]}`)
    .join('&');
}

export function handleOpenReactionModal({ reactions, reactionHeader = '' }) {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      showReactionModal: true,
      reactions,
      reactionHeader,
    })
  );
}

export function handleOkPopupFilterHomeStream() {
  const store = getStore();
  const { userInfo } = store.getState().loginReducer;
  const itemTooltip = userInfo.toolTips.find(itm => StreamFilterTooltip === itm.name);
  if (itemTooltip?.ViewCount <= itemTooltip.ToolTipType.DisplayLimit) {
    userService.patchUpdateAccountTooltips(itemTooltip.id);
  }
  WebIMConfig.blockScrollTop = false;
}

export function getHeaderDeleteText(message) {
  if (!message.bySelf && message.type !== TYPE_GROUP_CHAT) {
    return I18n.t('RemoveForYou');
  }
  switch (message?.body?.type) {
    case messageTypes.TYPE_GALLERY:
      return I18n.t('DeleteGallery');
    case messageTypes.TYPE_IMAGE:
    case messageTypes.TYPE_GIF:
      return I18n.t('DeletePhoto');
    case messageTypes.TYPE_VIDEO_FILE:
      return I18n.t('DeleteVideo');
    default:
      return I18n.t('DeleteMessage');
  }
}

export function getConfirmDeleteText(message) {
  switch (message?.body?.type) {
    case messageTypes.TYPE_GALLERY:
      return I18n.t('AreYouSureYouWantDeleteGallery_');
    case messageTypes.TYPE_IMAGE:
    case messageTypes.TYPE_GIF:
      return I18n.t('AreYouSureYouWantDeletePhoto_');
    case messageTypes.TYPE_VIDEO_FILE:
      return I18n.t('AreYouSureYouWantDeleteVideo');
    default:
      return I18n.t('AreYouSureYouWantDeleteMsg_');
  }
}

/**
 * Function show "NOT VIEWABLE" when user disables option Profile viewable
 * */
// export function handleShowProfileViewable({ history, isModal = false }) {
//   const store = getStore();
//   const { userInfo } = store.getState().loginReducer;
//   if (userInfo && userInfo.accountSettings && !userInfo.accountSettings.profileViewable) {
//     handleShowConfirmModal({
//       headerText: I18n.t('MenuUserSetting.ProfileVisibility'),
//       messageConfirm: I18n.t('MenuUserSetting.YourProfileIsSetToNotViewAble'),
//       messageConfirmExternal: I18n.t('MenuUserSetting.SetYourProfileToViewAble'),
//       okText: I18n.t('MenuUserSetting.SetProfileToViewable'),
//       okAction: () => {
//         store
//           .dispatch(
//             patchUpdateAccountSetting({
//               ProfileViewable: true,
//             })
//           )
//           .then(res => {
//             handleShowNotificationFromResult(res, I18n.t('NotificationScreen.YourProfileIsSetToShow'));
//           });
//       },
//       cancelText: I18n.t('Btn.NotNow'),
//       cancelAction: () => {
//         // console.log({ location: this.props.location });
//         if (isModal) {
//           // Close modal
//           store.dispatch(toggleProfileModal(false));
//           store.dispatch(resetStateMemberViewProfiles());
//         } else if (history) {
//           history.goBack();
//         }
//       },
//       disableClickOverlay: true,
//       noClearCancelAction: true,
//       disableEscClose: true,
//       disableBackBrowserCloseModal: true,
//     });
//   }
// }

export function decodeYoutubeUrl(url) {
  if (url) {
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);

    if (match && match[1]) {
      let type = 'Standard/Other';
      if (url.includes('shorts')) type = 'Shorts';
      if (url.includes('embed')) type = 'Embed';
      if (url.includes('youtu.be')) type = 'Shortened';

      return {
        // isYouTube: true,
        // id: match[1],
        // type: type,
        code: match[1],
      };
    }
  }

  return null;
}

export function decodeVimeoUrl(url) {
  if (url) {
    const urlVimeo1 = checkSameString(urls.URL_VIMEO, url);
    const urlVimeo2 = checkSameString(urls.URL_PLAYER_VIMEO, url);
    if (urlVimeo1 || urlVimeo2) {
      let strToken = url.split('//');
      if (strToken.length === 2) {
        strToken = strToken[1].split('/');
        if (strToken.length >= 2) {
          return { code: strToken[strToken.length - 1] };
        }
      }
    }
  }

  return null;
}

export function decodeAntMediaMP4(url) {
  if (url) {
    return checkSameString('.mp4', url);
  }

  return false;
}

export function removeWhileGapSafariMobile() {
  const isMobile = phoneDetect();
  if (getOS() === 'iOS' && isMobile && detectBrowser() === SAFARI) {
    // const html = document.getElementsByTagName('html')[0];
    // if (focus) {
    //   html.style.height = '-webkit-fill-available';
    //   // html.style.height = 'env(safe-area-inset-bottom)';
    //   // setTimeout(() => {
    //   //   html.style.height = `calc(100vh - 50px)`;
    //   // }, 250);
    //   // setTimeout(() => {
    //   //   html.style.height = `${window.innerWidth}px !important`;
    //   // }, 500);
    // } else {
    //   html.style.height = `${window.innerWidth}px !important`;
    // }
  }
}

export function isChromeAndroid() {
  return (
    navigator.userAgent.toLowerCase().indexOf('android') > -1 && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

export function animationScroll({ elm, stop, step, interval, type = SCROLL.VERTICAL }) {
  if (interval) {
    clearInterval(interval);
  }
  interval = setInterval(() => {
    if (type === SCROLL.VERTICAL) {
      elm.scrollTop += step;
      if ((step > 0 && elm.scrollTop >= stop) || (step < 0 && elm.scrollTop <= stop)) {
        elm.scrollTop = stop;
        clearInterval(interval);
      }
      if (step > 0 && elm.scrollTop + elm.offsetHeight >= elm.scrollHeight) {
        clearInterval(interval);
      }
      if (step < 0 && elm.scrollTop <= 0) {
        elm.scrollTop = 0;
        clearInterval(interval);
      }
    } else {
      elm.scrollLeft += step;
      if ((step > 0 && elm.scrollLeft + elm.offsetWidth >= stop) || (step < 0 && elm.scrollLeft <= stop)) {
        elm.scrollLeft = stop;
        clearInterval(interval);
      }
      if (step > 0 && elm.scrollLeft + elm.offsetWidth >= elm.scrollWidth) {
        clearInterval(interval);
      }
      if (step < 0 && elm.scrollLeft <= 0) {
        elm.scrollLeft = 0;
        clearInterval(interval);
      }
    }
  }, 10);
}

export function handleShowModalAccessDenied() {
  handleShowConfirmModal({
    headerText: I18n.t('AccessModal.AccessDenied'),
    messageConfirm: I18n.t('AccessModal.AccessDes'),
    okText: I18n.t('Btn.OkGotIt'),
    disableCancel: true,
  });
}

export function handleShowModalCommentsDisable() {
  handleShowConfirmModal({
    headerText: I18n.t('Community.CommentsDisabled'),
    messageConfirm: I18n.t('Community.CommentsDisabledTitle'),
    okText: I18n.t('Btn.OkGotIt'),
    disableCancel: true,
  });
}

export function getTextComment(count) {
  const _count = Number(count);
  if (_count === 1) {
    return `${_count} ${I18n.t('Comment')}`;
  }
  return `${_count} ${I18n.t('Comments')}`;
}

export function getTextLike(count) {
  if (count === 1) {
    return `${count} ${I18n.t('Like')}`;
  }
  return `${count} ${I18n.t('Likes')}`;
}

export function allowPostNewTopic() {
  const { userInfo } = getStore().getState().loginReducer;
  return userInfo && userInfo.grants && userInfo.grants.community && userInfo.grants.community.forumCanComment;
}

export function allowArticleCanComment() {
  const { userInfo } = getStore().getState().loginReducer;
  return userInfo && userInfo.grants && userInfo.grants.community && userInfo.grants.community.articleCanComment;
}

export function allowStoryCanComment() {
  const { userInfo } = getStore().getState().loginReducer;
  return userInfo && userInfo.grants && userInfo.grants.community && userInfo.grants.community.storyCanComment;
}

export function allowEventCanComment() {
  const { userInfo } = getStore().getState().loginReducer;
  return userInfo && userInfo.grants && userInfo.grants.community && userInfo.grants.community.eventCanComment;
}

export function handleUpdateColorStatusBar() {
  const themeColor = document.querySelector('meta[name="theme-color"]');
  const themeColorWinPhone = document.querySelector('meta[name="msapplication-navbutton-color"]');
  const themeColorIOSSafari = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
  let color = '#f4f4f4';
  const { pathname, search } = window.location;
  const { query } = queryString.parseUrl(search);
  switch (pathname) {
    case `${ROOT_FOLDER}/${FEED_HOME}`:
      if (!!query.setting) {
        color = '#ffffff';
      }
      break;
    case `${ROOT_FOLDER}/${MAIN_SETTING}`:
    case `${ROOT_FOLDER}/${ALL_PROPERTY_VIEW}`:
    case `${ROOT_FOLDER}/${ADD_YOUR_PHOTO}`:
    case `${ROOT_FOLDER}/${QUICK_REGISTRATION}`:
    case `${ROOT_FOLDER}/${QUICK_REGISTRATION_2}`:
    case `${ROOT_FOLDER}/${EDIT_PROFILE}`:
      color = '#ffffff';
      break;
    default:
      break;
  }

  themeColor.setAttribute('content', color);
  themeColorWinPhone.setAttribute('content', color);
  themeColorIOSSafari.setAttribute('content', color);
}

export function handleOpenRHPCoins(needMoreCoins = 0, callback) {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowRHPCoins: true,
      needMoreCoins,
      callbackAfterGetMoreCoinsSuccess: callback,
    })
  );
}

export function convertMemberLever(memberLevel, useDiamondBlack = false) {
  const item = {
    text: 'MemberProfileScreen.MemberGuest',
    className: 'level-button guest',
    icon: null,
  };
  switch (memberLevel) {
    case MEMBER_LEVEL.PLUS:
      item.text = 'MemberProfileScreen.Plus';
      item.className = 'level-button plus';
      break;
    case MEMBER_LEVEL.EXTRAS:
    case MEMBER_LEVEL.PLUS_EXTRAS:
      item.text = 'MemberProfileScreen.Extras';
      item.className = 'level-button extras';
      break;
    case MEMBER_LEVEL.PREMIUM:
      item.text = 'MemberProfileScreen.MemberPremium';
      item.className = 'level-button premium';
      break;
    case MEMBER_LEVEL.PREMIUM_PLUS:
      item.text = 'MemberProfileScreen.MemberPremiumPlus';
      item.className = 'level-button premium-plus';
      break;
    case MEMBER_LEVEL.PLATINUM:
      item.text = 'MemberProfileScreen.MemberPlatinum';
      item.className = 'level-button platinum';
      break;
    case MEMBER_LEVEL.DIAMOND:
      item.text = 'MemberProfileScreen.MemberPlatinum';
      item.className = 'level-button platinum';
      item.icon = <Img src={useDiamondBlack ? icDiamondBlack : icDiamondMember} alt="diamond" />;
      break;
    default:
      break;
  }

  return item;
}

export function handleOpenGetMoreConversationCredit() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowModalGetConversations: true,
    })
  );
}

export function handleOpenPurchasesCoins() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowPurchasesCoins: true,
    })
  );
}

export function handleOpenDiamonds() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowDiamonds: true,
    })
  );
}

export function isInViewport(element) {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function handleOpenConversationCredits() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowConversationCredits: true,
    })
  );
}

export function handleShowAboutGifts() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowIntroducingMessengerGiftModal: true,
    })
  );
}

export function handleShowSubscriptionsModal() {
  const store = getStore();
  store.dispatch(
    updateCommonStateReducerSuccess({
      isShowModalSubscription: true,
    })
  );
}

export function handleShowRatingModal() {
  const store = getStore();
  store.dispatch(updateStateCommonState(['isShowRatingModal'], true));
}

export function removeSpace(str) {
  return str.trim().length === 0 ? str.trim() : str;
}

export function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

export function getGoogleMapLink(location) {
  if (!location) {
    return '';
  }
  const locationString = encodeURI(`${location.latitude},${location.longitude}`);
  return `https://www.google.com/maps/place/${locationString}`;
}

export function sendEventShowQuickMessageModal() {
  const quickMessageEvent = new CustomEvent(SHOW_QUICK_MESSAGE_MODAL, {
    bubbles: true,
    cancelable: true,
    detail: {},
  });
  window.dispatchEvent(quickMessageEvent);
}

export function sendEventClearCountdownVideoCall() {
  window.dispatchEvent(
    new CustomEvent(CLEAR_COUNTDOWN, {
      bubbles: false,
      cancelable: false,
      detail: {},
    })
  );
}

export function convertDataForCarouselView(data) {
  const res = [];
  if (data) {
    data.forEach((itm, index) => {
      itm.data.forEach((item, idx) => {
        if (item) {
          const resItem = {};
          resItem.detail = {
            ...item.profile,
            location: item.location,
          };
          resItem.mainPhotoSummary = { ...item.profile.mainPhoto };
          resItem.indexGroupDateFinder = index;
          resItem.dateFinderItem = { ...item };
          resItem.indexItem = idx;

          res.push(resItem);
        }
      });
    });
  }

  return res;
}

export function convertDataForGridView(dates) {
  const dateFinders = [];
  if (dates && dates.length > 0) {
    dates.forEach((item, index) => {
      if (item && item.data && item.data.length > 0) {
        item.data.forEach((currentItem, currentIndex) => {
          dateFinders.push({
            ...currentItem,
            profile: {
              ...currentItem.profile,
              location: currentItem.location,
            },
            indexGroupDateFinder: index,
            indexItem: currentIndex,
          });
        });
      }
    });
  }
  return dateFinders;
}

export function cmRegisterRefWithKey(elm, key, refs) {
  if (refs && refs.current) {
    const refExists = refs.current.find(i => i.key === key);
    if (!refExists) {
      refs.current.push({ elm, key });
    } else {
      const newRefItems = refs.current.filter(i => i.key !== key);
      newRefItems.push({ elm, key });
      refs.current = newRefItems;
    }
  } else {
    console.log('Register failed');
  }
}

export function cmGetRefWithKey(key, refs) {
  if (refs && refs.current) {
    return refs.current.find(i => i.key.toString() === key.toString())?.elm;
  } else {
    console.log('Get Ref failed');
  }
  return null;
}

export function showUnavailablePopup({ publicGroupChat, onClickTry }) {
  handleShowConfirmModal({
    headerText: publicGroupChat ? I18n.t('MessengerUnavailable.TitleChatRoom') : I18n.t('MessengerUnavailable.Title'),
    messageConfirm: publicGroupChat ? I18n.t('MessengerUnavailable.Des1ChatRoom') : I18n.t('MessengerUnavailable.Des1'),
    className: STYLE_MODAL.BLOCK_MODAL,
    okText: I18n.t('Btn.OkGotIt'),
    okAction: () => {
      onClickTry?.();
    },
    // cancelText: I18n.t('Btn.Retry'),
    // cancelAction: () => {
    //   onClickTry?.();
    // },
    disableCancel: true,
    noClearCancelAction: true,
    disableClickOverlay: true,
  });
}

export function blockInvalidCharNumber(e) {
  return ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
}

export function resetUrlConversation() {
  const searchNewParams = new URL(window.location.href).searchParams;
  searchNewParams.set('curNode', undefined);
  const url = `${window.location.pathname}?${searchNewParams}`;
  return url;
}

export function stopEvent(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
}

export function hasScroll(element) {
  const hasVerticalScroll = element.scrollHeight > element.clientHeight;
  const hasHorizontalScroll = element.scrollWidth > element.clientWidth;
  return { hasVerticalScroll, hasHorizontalScroll };
}

export function getIconGroupButtonByTheme(theme) {
  switch (theme) {
    case THEMES.PINK:
      return icChevronPinkRight;
    case THEMES.PURPLE:
      return icChevronPurpleRight;
    case THEMES.BLUE:
      return icChevronBlueRight;
    default:
      return icChevronGreenRight;
  }
}

export function getIconSendByTheme(theme, isMobile) {
  if (isMobile) {
  }

  switch (theme) {
    case THEMES.PINK:
      return icSendPink;
    case THEMES.PURPLE:
      return icSendPurple;
    case THEMES.BLUE:
      return icSendBlue;
    default:
      return icSend;
  }
}

export function getIconCallByTheme(theme, isMobile) {
  if (isMobile) {
  }

  switch (theme) {
    case THEMES.PINK:
      return icVoicePink;
    case THEMES.PURPLE:
      return icVoicePurple;
    case THEMES.BLUE:
      return icVoiceBlue;
    default:
      return icVoiceGreen;
  }
}

export function getIconVideoByTheme(theme, isMobile) {
  if (isMobile) {
  }

  switch (theme) {
    case THEMES.PINK:
      return icCameraPink;
    case THEMES.PURPLE:
      return icCameraPurple;
    case THEMES.BLUE:
      return icCameraBlue;
    default:
      return icCameraGreen;
  }
}

export function checkCorrectString(strReg, value) {
  const tmpRex = new RegExp(strReg);

  return tmpRex.test(value);
}

export function handleIframeDirect(path, ignoreIframeDirect = false) {
  const isInIframe = window.location !== window.parent.location;
  if (isInIframe && !ignoreIframeDirect) {
    // window.parent.location.href = path;
    window.parent.open(path, '_self');
  } else {
    // window.location.href = path;
    window.open(path, '_self');
  }
}

export function parseObjectToUrlSearch(_obj) {
  let search = '';
  if (typeof _obj !== 'object') {
    return search;
  }

  Object.keys(_obj).forEach(key => {
    let value = _obj[key];

    if (typeof value === 'string') {
      value = value.trim();
    }
    if (typeof value === 'number') {
      if (value === -1) {
        value = '';
      } else {
        value += '';
      }
    }

    if (value) {
      if (!search) {
        search = `${key}=${encodeURIComponent(value)}`;
      } else {
        search += `&${key}=${encodeURIComponent(value)}`;
      }
    }
  });

  return search;
}

/**
 * Parse URL search query string into an object
 * @param {string} search - The search query string (e.g., "?key1=value1&key2=value2")
 * @returns {any} Object with parsed query parameters
 */
export function parseSearchQuery(search) {
  const res = {};

  // Handle empty or undefined search
  if (!search || typeof search !== 'string') {
    return { query: res };
  }

  // Remove leading ? if present
  const queryString = search.startsWith('?') ? search.substring(1) : search;

  // Handle empty query string
  if (!queryString.trim()) {
    return { query: res };
  }

  // Split by & and process each pair
  queryString.split('&').forEach(pair => {
    if (!pair) return;

    const equalPos = pair.indexOf('=');
    let key, value;

    // Handle parameters with and without values
    if (equalPos === -1) {
      key = pair;
      value = '';
    } else {
      key = pair.substring(0, equalPos);
      value = pair.substring(equalPos + 1);
    }

    // Skip empty keys
    if (!key) return;

    // Safely decode URI components
    try {
      key = decodeURIComponent(key);
      value = value ? decodeURIComponent(value) : '';

      // Store in result object
      res[key] = value;
    } catch (e) {
      // Handle malformed URI components by using raw values
      console.warn('Error decoding URI component:', e);
      res[key] = value || '';
    }
  });

  return { query: res };
}

/**
 *
 * @returns any
 */
export const getBiometricData = () => {
  const biometricDataString = storageHelper.getKey(SESSIONS.BIOMETRIC_DATA);
  if (!biometricDataString) {
    return {};
  }

  try {
    const biometricData = JSON.parse(biometricDataString);
    return Object.keys(biometricData).reduce((result, key) => {
      try {
        result[key] = biometricData[key] ? JSON.parse(decrypt.decrypt(biometricData[key]) || 'undefined') : undefined;
      } catch (error) {
        console.error(`Error decrypting or parsing biometric data for key: ${key}`, error);
        result[key] = undefined; // Or handle the error as needed, e.g., skip the key
      }
      return result;
    }, {});
  } catch (error) {
    console.error('Error parsing biometric data from storage:', error);
    return {};
  }
};

/**
 *
 * @param {*} data is BiometricUser
 * @param {*} key is user display name
 * @returns
 */
export const setUserBiometricData = (data, key) => {
  try {
    if (!encrypt.getPublicKey()) {
      console.error('Public key not set properly');
      return false;
    }

    if (!data || typeof data !== 'object') {
      console.error('Invalid biometric data format');
      return false;
    }

    const dataString = JSON.stringify(data);
    if (!dataString) {
      console.error('Failed to stringify biometric data');
      return false;
    }
    const biometricDataString = storageHelper.getKey(SESSIONS.BIOMETRIC_DATA);
    const biometricData = JSON.parse(biometricDataString || '{}');
    biometricData[key] = encrypt.encrypt(dataString);
    setBiometricData(biometricData);
    return biometricData[key];
  } catch (error) {
    console.error('Error in setUserBiometricData:', error);
    return false;
  }
};

export const setBiometricData = biometricData => {
  try {
    if (!biometricData || typeof biometricData !== 'object') {
      console.error('Invalid biometric data format');
      return false;
    }

    storageHelper.setKey(SESSIONS.BIOMETRIC_DATA, JSON.stringify(biometricData));
    return true;
  } catch (error) {
    console.error('Error in setBiometricData:', error);
    return false;
  }
};

export const deleteBiometricData = key => {
  const biometricData = getBiometricData();
  delete biometricData[key];
  return setBiometricData(biometricData);
};

export function parseDateString(dateString) {
  const milliseconds = parseInt(dateString.substring(6, dateString.length - 2));
  const dateObject = new Date(milliseconds);
  return dateObject.getTime(); // Returns the Unix timestamp in milliseconds
}

export function getDimensionImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
    img.src = url;
  });
}

export function getDimensionImageFile(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export async function isDimensionImageValid(file) {
  const dimension = await getDimensionImageFile(file);
  console.log('dimension', dimension);
  return dimension.width >= MIN_DIMENSION_IMAGE.WIDTH && dimension.height >= MIN_DIMENSION_IMAGE.HEIGHT;
}

/**
 * Parses a Microsoft/ASP.NET date string and formats it using provided options.
 *
 * @param {string} msDateString The date string, e.g., "/Date(1757467912867+0800)/"
 * @param {Intl.DateTimeFormatOptions} options Options for Intl.DateTimeFormat (e.g., { weekday: 'short', day: '2-digit', month: 'short' })
 * @param {string} [locale='en-US'] The locale to use for formatting.
 * @returns {string | null} The formatted date string, or null on failure.
 */
export function formatMsDate(msDateString, options, locale = 'en-US') {
  // 1. Use your existing function to get the Unix timestamp (in seconds)
  const unixTimestamp = convertMsDateToUnixTimestamp(msDateString);

  if (unixTimestamp === null) {
    // Your parser is expected to handle errors, so we return null if the timestamp is not retrieved.
    return null;
  }

  // 2. Convert Unix seconds back to milliseconds for the JavaScript Date object
  // Special case: If timestamp is 0, it still points to the epoch (Jan 1, 1970).
  const date = new Date(unixTimestamp * 1000);

  // 3. Format the date using the provided options
  try {
    const formatter = new Intl.DateTimeFormat(locale, options);
    const formattedDate = formatter.format(date);

    // 4. Clean up the output to remove commas often inserted by default locales (like "Sat, 04 Jan")
    return formattedDate.replace(/,/, '').replace(/\s+/g, ' ').trim();
  } catch (e) {
    console.error('Error formatting date:', e);
    return null;
  }
}

// Get visible count of text with range, should ignore new line character
export function getVisibleCountWithRange(element) {
  const textNode = element.firstChild; // Assumes first child is the text
  if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return 0;

  const range = document.createRange();
  const containerRect = element.getBoundingClientRect();
  let count = 0;

  for (let i = 0; i < textNode.length; i++) {
    if (textNode.textContent[i] === '\n') {
      count++;
      continue;
    }

    // Set the range to cover exactly one character
    range.setStart(textNode, i);
    range.setEnd(textNode, i + 1);

    const charRect = range.getBoundingClientRect();

    // Check if the right edge of the character exceeds the container
    // (Subtracting ~20px to account for the ellipsis width)
    if (charRect.right > containerRect.right - 20) {
      break;
    }
    count++;
  }

  return count;
}

/**
 * Remove a single param from a URL search query string and return the
 * remaining params re-encoded. Same return convention as
 * parseObjectToUrlSearch: no leading '?' (empty string when nothing is
 * left) — prepend '?' at the call site when the result is non-empty.
 * @param {string} search - The search query string (e.g., "?key1=value1&key2=value2")
 * @param {string} paramKey - The param name to remove
 * @returns {string} Remaining query string, without the leading '?'
 *
 * @example
 * // applying the result back onto the current URL:
 * const newSearch = removeSearchParam(location.search, 'gclid');
 * history.replace(`${location.pathname}${newSearch ? `?${newSearch}` : ''}`);
 */
export function removeSearchParam(search, paramKey) {
  const { query } = parseSearchQuery(search);
  const { [paramKey]: _removed, ...rest } = query;
  return parseObjectToUrlSearch(rest);
}
